import api from "./api";

const Login = "/login/checklogin/";
const isAuthenticated = () => {
  return localStorage.getItem("user") && localStorage.getItem("user") !== "null"
    ? true
    : false;
};
const currentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const checkLogin = (username, password) =>
  api.post(Login + `username=${username}&password=${password}`);

export default {
  checkLogin,
  isAuthenticated,
  currentUser,
};
